import React from "react";
import { StyleSheet, View } from "react-native";

import ProfileCard from "./ProfileCard";
import {
  type LandingIntent,
  PHRASES_BY_INTENT,
  type Theme,
  themeConfigs,
} from "./profileThemes";

import { MARKETING_THEME } from "@/utils/expo";
import { shuffleArray } from "@/utils/randomize";

interface ProfileGridProps {
  theme?: Theme;
  intent?: LandingIntent;
}

const ProfileGrid: React.FC<ProfileGridProps> = ({
  theme = MARKETING_THEME,
  intent,
}) => {
  const profiles = [...themeConfigs[theme]];
  shuffleArray(profiles);

  const phraseSet = intent !== undefined ? PHRASES_BY_INTENT[intent] : null;

  return (
    <View style={styles.grid}>
      {profiles.map((profile, index) => (
        <ProfileCard
          key={index}
          {...profile}
          phrase={
            phraseSet !== null
              ? (phraseSet[index % phraseSet.length] ?? profile.phrase)
              : profile.phrase
          }
        />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  grid: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    marginBottom: 24,
  },
});

export default ProfileGrid;
